export default __webpack_public_path__ + "static/media/frame-2.5910dcfa.jpg";